import Cookies from 'js-cookie';
import { COOKIE_DOMAIN } from '@/constants/storage/cookies';

interface CookieOptions {
  readonly domain?: string;
  readonly path?: string;
  readonly expires?: number;
}

const DEFAULT_OPTIONS: CookieOptions = {
  domain: COOKIE_DOMAIN,
} as const;

class CookiesUtils {
  public getCookie(key: string, defaultVal?: any): string | null {
    const valFromCookie = Cookies.get(key);
    if (valFromCookie !== undefined) {
      return valFromCookie;
    }
    if (defaultVal !== undefined) {
      return defaultVal;
    }
    return null;
  }

  public getBooleanCookie(key: string, defaultVal = false): boolean {
    const value = this.getCookie(key);
    if (value === null) {
      return defaultVal;
    }
    return value === 'true' || value === '1';
  }

  public setCookie(key: string, value: string, options?: CookieOptions) {
    Cookies.set(key, value, { ...DEFAULT_OPTIONS, ...options });
  }

  public removeCookie(key: string, options?: CookieOptions) {
    Cookies.remove(key, { ...DEFAULT_OPTIONS, ...options });
  }

  /** writes without URL-encoding to match the extension's raw cookie format */
  public setRawCookie(key: string, value: string): void {
    document.cookie = `${key}=${value}; domain=${COOKIE_DOMAIN}; path=/`;
  }
}

export const cookiesUtils = new CookiesUtils();
